export default {
  pathway1: {
    collection_1_grade_9: '1. Get-To-Know-You-Bingo',
    collection_1_grade_10: '2. Get-To-Know-You-Bingo',
    collection_1_grade_11: '3. Get-To-Know-You-Bingo',
    collection_1_grade_12: '4. Get-To-Know-You-Bingo',
    collection_2_grade_9: `1. Let's Connect`,
    collection_2_grade_10: `2. Let's Connect`,
    collection_2_grade_11: `3. Let's Connect`,
    collection_2_grade_12: `4. Let's Connect`,
    collection_3_grade_9: '1. Imaginary Audience',
    collection_3_grade_10: '2. Digital Connections',
    collection_3_grade_11: '3. Repairing Relationships',
    collection_3_grade_12: `4. What's Fundamental Attribution Error?`,
    title: 'Pathway 1: Belonging & Connection',
  },
  pathway2: {
    collection_1_grade_9: '1. Visualizing Success',
    collection_1_grade_10: '2. Visualizing Success',
    collection_1_grade_11: '3. Visualizing Success',
    collection_1_grade_12: '4. Visualizing Success',
    collection_2_grade_9: '1. Identifying Obstacles',
    collection_2_grade_10: '2. Anticipating Obstacles',
    collection_2_grade_11: '3. Addressing Self-Sabotage',
    collection_2_grade_12: '4. Staying Positive and Confident',
    collection_3_grade_9: '1. View, Analyze, Believe',
    collection_3_grade_10: '2. Practical Positive Thinking',
    collection_3_grade_11: '3. Balancing Online Time',
    collection_3_grade_12: '4. Expanding Networks for Success',
    title: 'Pathway 2: Confidence & Capability',
  },
  pathway3: {
    collection_1_grade_9: '1. Guess Who?',
    collection_1_grade_10: '2. Guess Who?',
    collection_1_grade_11: '3. Guess Who?',
    collection_1_grade_12: '4. Guess Who?',
    collection_2_grade_9: '1. Introduction to Strengths',
    collection_2_grade_10: '2. Identifying Shared Strengths',
    collection_2_grade_11: '3. Strengths Mapping',
    collection_2_grade_12: '4. Collective Contributions',
    collection_3_grade_9: '1. Exploring Experiences',
    collection_3_grade_10: '2. Exploring Experiences',
    collection_3_grade_11: '3. Exploring Experiences',
    collection_3_grade_12: '4. Exploring Experiences',
    title: 'Pathway 3: Agency & Opportunity',
  },
  pathway4: {
    collection_1_grade_9: '1. Naming Emotions',
    collection_1_grade_10: '2. Memories from Past and Future',
    collection_1_grade_11: '3. Identifying and Managing Emotions',
    collection_1_grade_12: '4. Compassion for a Friend',
    collection_2_grade_9: '1. Thoughtful Focus',
    collection_2_grade_10: '2. Sharing Positive Emotions',
    collection_2_grade_11: '3. Photo Perspectives',
    collection_2_grade_12: '4. Practicing Self-Compassion',
    collection_3_grade_9: '1. What Would You Do?',
    collection_3_grade_10: '2. Showing Gratitude',
    collection_3_grade_11: `3. What's Normal?`,
    collection_3_grade_12: '4. Self-Compassionate Writing',
    title: 'Pathway 4: Well-Being & Community',
  },
}
